export const SeasonInfoDetailsSkeleton = () => {
	return (
		<>
			<div>
				<div className="animate-pulse rounded-xl bg-white p-4 shadow-md">
					<h3 className="mb-4 h-6 w-48 rounded bg-gray-200"></h3>
					<div className="mt-4 flex flex-col">
						<div className="mb-2 flex">
							<div className="h-4 w-32 rounded bg-gray-200"></div>
						</div>
						<div className="mb-2 flex">
							<div className="h-4 w-28 rounded bg-gray-200"></div>
						</div>
						<div className="mb-2 flex">
							<div className="h-4 w-48 rounded bg-gray-200"></div>
						</div>
					</div>
				</div>
			</div>

			{/* Description */}
			<div>
				<div className="mb-4 min-h-[216px] animate-pulse rounded-lg bg-white p-4 shadow-md">
					<h3 className="mb-4 h-6 w-48 rounded bg-gray-200"></h3>
					<div className="h-4 w-60 rounded bg-gray-200"></div>
				</div>
			</div>
		</>
	);
};
